import { Stack } from '@cheqroom/ui';
import tw, { styled } from 'twin.macro';

export const StyledSelectField = styled(Stack)<{ disabled: boolean }>`
	${tw`bg-white border-gray-200 border rounded px-2 py-1`}
	${({ disabled }) => disabled && tw`opacity-50`}
`;
